import { EntityColumnOptions, entityColumn } from "components/UI/Table/columns/entity/entityColumn.tsx";
import { FILTER_TYPES } from "components/UI/Table/constants/filter.ts";
import { TableColumnType } from "components/UI/Table/types/table.ts";

import UserData = App.Data.UserData;

interface AdvertisersColumnOptions<T> extends EntityColumnOptions<T, UserData[]> {
    emptyLabel?: string;
}

export const AdvertisersColumn = <T,>(options: AdvertisersColumnOptions<T>): TableColumnType<T> => {
    const { emptyLabel = "-", ...columnOptions } = options;

    return entityColumn<T, UserData[]>(
        {
            dataIndex: "advertisers",
            key: "advertisers",
            sorter: true,
            filterable: true,
            filterType: FILTER_TYPES.advertiserSelect,
            filterName: "advertisers.id",
            sortName: "advertisers.nickname",
            filterIncludeNull: true,
            filterNullOptionLabel: emptyLabel,
            ellipsis: true,
        },
        (advertisers) =>
            advertisers?.length
                ? advertisers.map((advertiser) => advertiser.nickname ?? emptyLabel).join(", ")
                : emptyLabel,
        columnOptions
    );
};
